// @flow
import React from 'react'
import styled, { type StyledComponent } from 'styled-components'
import type { Node, PlacementNode } from '../types'

const DESELECTOR = '[x]'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  height: 20px;
  padding-right: 4px;
`

const Deselector: StyledComponent<Object, any, any> = styled.a`
  padding-left: 2px;
  text-decoration: none;
  color: ${({ isDisabled }: Object) => (isDisabled ? '#ccc' : '#2099ca')};

  &:hover {
    cursor: ${({ isDisabled }: Object) => (isDisabled ? 'default' : 'pointer')};
  }
`

type Props = {|
  node: Node | PlacementNode,
  onDeselect: Function,
  isDisabled?: boolean
|}

export default function SelectedInline(props: Props) {
  const { node, onDeselect, isDisabled } = props

  return (
    <Wrapper key={node.id || node.label}>
      {node.label}
      <Deselector isDisabled={isDisabled} onClick={handleClick(node, onDeselect)} href="#">
        {DESELECTOR}
      </Deselector>
    </Wrapper>
  )
}

function handleClick(node, onDeselect) {
  return (event) => {
    event.preventDefault()
    onDeselect(node)
  }
}
